<template>
  <div>
    <div class="filter-label">
      Alert Category
    </div>
    <div class="filter-options">
      <SACCheckbox
        label="Performance"
        field="alertType"
        :checked="existingAlertCategory.includes('Performance')"
        :change="() => handleSystemFilters(
          'alertCategoryFilter',
          'Performance',
          !!existingAlertCategory.includes('Performance'))"
      />
      <SACCheckbox
        label="Leak"
        field="alertType"
        :checked="existingAlertCategory.includes('Leak')"
        :change="() => handleSystemFilters(
          'alertCategoryFilter',
          'Leak',
          !!existingAlertCategory.includes('Leak'))"
      />
      <SACCheckbox
        label="Filter"
        field="alertType"
        :checked="existingAlertCategory.includes('Filter')"
        :change="() => handleSystemFilters(
          'alertCategoryFilter',
          'Filter',
          !!existingAlertCategory.includes('Filter'))"
      />
      <SACCheckbox
        label="Device"
        field="alertType"
        :checked="existingAlertCategory.includes('Device')"
        :change="() => handleSystemFilters(
          'alertCategoryFilter',
          'Device',
          !!existingAlertCategory.includes('Device'))"
      />
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex';
import SACCheckbox from '../../sac/SACCheckbox.vue';

export default {
  name: 'AlertTypeFilter',
  components: {
    SACCheckbox,
  },
  computed: {
    ...mapState({
      existingAlertCategory: state => state.customerDetail.systemFilter.alertCategoryFilter,
    }),
  },
  methods: {
    handleSystemFilters(field, value, checked) {
      this.$store.dispatch('setDetailSystemFilter', {
        field,
        value,
        checked,
      });
    },
  },
};
</script>

<style scoped>

</style>
